/**
 * Regras do botão "Editar" numa bolha enviada. Espelho da rota
 * POST /messages/:id/edit — a API é a fonte da verdade; aqui só decidimos
 * quando MOSTRAR o botão.
 */
import { agoraDoServidor } from './relogio-do-servidor';
import type { ChatMessage } from './types';

/** Igual ao EDIT_WINDOW_MS da API e ao app do WhatsApp. */
export const PRAZO_DE_EDICAO_MS = 15 * 60 * 1000;

export interface ContextoDeEdicao {
  /** Usuário logado. */
  userId: number | null | undefined;
  /** Admin ou login de suporte — editam msg de qualquer atendente. */
  podeEditarDeOutros: boolean;
  /** Canal QR (zapo/whatsmeow). A Cloud API não tem edição de msg enviada. */
  canalQr: boolean;
  /** "Permitir edição de mensagem" ligado nas Configurações do canal
   *  (nasce desligado — migration 0102). */
  canalPermite: boolean;
}

/** Tudo menos o prazo (que muda com o tempo — checado no hover). */
export function podeEditarMensagem(m: ChatMessage, ctx: ContextoDeEdicao): boolean {
  if (!ctx.canalQr || !ctx.canalPermite) return false;
  if (m.direction !== 'outbound' || m.type !== 'text' || m.internal_note) return false;
  if (!m.wamid || m.deleted_at) return false;
  const souAutor = ctx.userId != null && m.sent_by_user_id === ctx.userId;
  return souAutor || ctx.podeEditarDeOutros;
}

/** Ainda dá pra editar? Relógio do SERVIDOR (o do PC pode estar torto). */
export function dentroDoPrazoDeEdicao(
  sentAt: string | null | undefined,
  agoraMs: number = agoraDoServidor(),
): boolean {
  if (!sentAt) return false;
  const enviadaEm = new Date(sentAt).getTime();
  return Number.isFinite(enviadaEm) && agoraMs - enviadaEm <= PRAZO_DE_EDICAO_MS;
}

/** Motivo do `message.edit.failed` (worker) → texto pro atendente. */
export function motivoDaFalhaDeEdicao(reason: string | undefined): string {
  switch (reason) {
    case 'canal_desconectado':
      return 'O canal está desconectado. Reconecte e tente de novo.';
    case 'whatsapp_recusou':
      return 'O WhatsApp recusou a edição — o prazo pode ter acabado.';
    default:
      return 'A mensagem continua com o texto anterior. Tente de novo.';
  }
}
